import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { ReactComponent as Notification } from '../../../images/Notifications.svg';
import { ReactComponent as Back } from '../../../images/arrow/left.svg';
import { ReactComponent as EditIcon } from '../../../images/edit.svg';
import { ReactComponent as DotIcon } from '../../../images/dot.svg';
import { ReactComponent as SetIcon } from '../../../images/3.svg';
import { ReactComponent as CheckIcon } from '../../../images/check.svg';
import { ReactComponent as CrossIcon } from '../../../images/closeCross1.svg';
export const IconEdit = styled(EditIcon)`
  width: 24px;
  height: 24px;
fill:currentColor

`;


export const IconCheck = styled(CheckIcon)`
  width: 24px;
  height: 24px;


`;
export const IconCross = styled(CrossIcon)`
  width: 20px;
  height: 20px;
stroke: var(--colors-error-500);

`;


export const IconMenu = styled(SetIcon)`
  width: 24px;
  height: 24px;
  font-size: 24px;
  stroke: currentColor;
  stroke: var(--colors-primary-600);
  color: currentColor;
&.active{
stroke: var(--colors-grey-25);

}
 
`;

export const ChoiceButton = styled.button`
  width: 36px;
  height: 36px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  background: transparent;

  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;


export const SetBox = styled.div`
position: relative;
padding: 12px;
width: 48px;
height: 48px;
border-radius: 12px;
&.active{
 background: var(--colors-primary-400);

}
`;

export const Container1 = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 77px);


     @media (max-width: 1024px) {
  

   };
    @media (max-width: 844px) {
  
    }
      @media (max-width: 690px) {
  align-items: flex-start;
flex-direction: column;
width:calc(100% - 74px); 
gap: 15px; 
}
   
`;



export const Container = styled.header`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
  width: 100%;
min-width: 1024px;
   @media (max-width: 1440px) {
     padding-bottom: 20px;
min-width: 872px;
   };
     @media (max-width: 1024px) {
  
min-width: 616px;
   };
    @media (max-width: 844px) {
  
min-width: 342px;
   };
      @media (max-width: 689px) {
  align-items: flex-start;

   };
   
`;

export const Wrapper = styled.div`
  display: ${props => (props.hide = 'true' ? 'none' : 'flex')};
  margin-right: auto;

  /* @media screen and (min-width: 1440px) {
    display: ${props => (props.hide = 'true' ? 'flex' : 'none')};
  } */
`;

export const Picture = styled.picture`
  width: 64px;
  height: 60px;
  margin-right: 8px;
`;

export const Imeges = styled.img`
  width: 64px;
  height: 60px;
`;

export const WrapperText = styled.div`
  display: grid;
  gap: 8px;
`;

export const PageHeader = styled.p`
  /* display: ${props => (props.hide = 'true' ? 'none' : 'block')}; */
  display: block;
  color: var(--colors-grey-900);
  margin-right: ${props => (props.tasksСompleted ? 'auto' : '16px')};

    font-weight: 600;
font-size: 24px;
line-height: 125%;

  @media  (max-width: 1440px) {
  
  }
    @media  (max-width: 1024px) {
    
  }
`;
/* 
export const NotificWrap = styled.div`
  margin-left: auto;
  position: relative;
  
   &::after{
    display: ${props => props.hide === "true" ? "block" : "none"};
  content: "";
  position: absolute;
  right: 0;
  top:0;
background: var(--colors-error-500);
  border-radius: 360px;
width: 12px;
height: 12px;
 }
`; */

export const NotificWrap = styled.div`
  margin-left: auto;

  position: ${({ floating }) => (floating ? 'fixed' : 'relative')};
  top: ${({ floating }) => (floating ? '16px' : 'auto')};
  right: ${({ floating }) => (floating ? '80px' : 'auto')};

  width: 48px;
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: ${({ floating }) => (floating ? 2000 : 'auto')};

  background: ${({ floating }) => (floating ? '#fff' : 'transparent')};
  border-radius: 50%;

  box-shadow: ${({ floating }) =>
    floating ? '0 4px 16px rgba(0,0,0,0.2)' : 'none'};

  transition: all 0.25s ease;

  /* 🔴 індикатор нових повідомлень */
  &::after {
    display: ${({ hide }) => (hide === 'true' ? 'block' : 'none')};
    content: '';
    position: absolute;
    right: 6px;
    top: 6px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--colors-error-500);
    z-index: 3;
  }

  /* ✨ pulse (1 раз на 5 секунд) */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    pointer-events: none;

    animation: ${({ floating }) =>
      floating ? 'pulse 5s infinite' : 'none'};
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.45);
      opacity: 1;
    }
    15% {
      box-shadow: 0 0 0 14px rgba(255, 0, 0, 0);
      opacity: 0;
    }
    100% {
      box-shadow: 0 0 0 14px rgba(255, 0, 0, 0);
      opacity: 0;
    }
  }  

   @media (max-width: 1440px) {
   


    right: ${({ floating }) => (floating ? '40px' : 'auto')};
  }

  @media (max-width: 844px) {
    width: 44px;
    height: 44px;

    top: ${({ floating }) => (floating ? '20px' : 'auto')};
    right: ${({ floating }) => (floating ? '75px' : 'auto')};
  }
`;



export const NotificBtn = styled(Notification)`
  width: 24px;
  height: 24px;
  color: var(--colors-grey-400);
  cursor: pointer;
  flex-shrink: 0;

  @media (max-width: 844px) {
    width: 20px;
    height: 20px;
  }
`;

export const BackIcon = styled(Back)`


  width: 32px;
  height: 32px;
 

 color: var(--colors-grey-400);


 
`;

export const ButtonBack = styled.div`
font-family: var(--font-family);
font-weight: 500;
font-size: 20px;
line-height: 135%;
color: var(--colors-grey-500);
display: flex;
gap:12px ;
align-items: center;
  cursor: pointer;
`


export const ChangeButton = styled.button`
margin-left: 10px;
margin-right: 20px;
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-grey-25);
gap:8px;
display: flex;
align-items: center;

background:var(--colors-primary-600);
border-radius: 360px;
padding: 8px 24px;
cursor: pointer;

  @media (max-width: 844px) {
border-radius: 8px;
padding: 8px;
width: 32px;
height: 32px;
  
  } 

    @media (max-width: 535px) {
margin-right: 0;
  
  } 
`;

export const Span = styled.span`
@media (max-width: 844px) {
  display: none;
  } 
`;

export const ShopBox = styled.div`
display: flex;
align-items: center;
position: relative;
@media (max-width: 953px) {                                                                             
  width: calc(100% - 100px );
  } 

@media (max-width: 844px) {                                                                             
  width: calc(100% - 147px );
  } 
  @media (max-width: 690px) {                                                                             
  width: calc(100% + 47px );
  } 


@media (max-width: 488px) {

  gap:4px;
 align-items: start;
 min-width: 342px;
  } 
`

export const TimeBox = styled.div`
margin-left: 20px;
font-family: var(--font-family);
font-weight: 500;
font-size: 20px;
line-height: 135%;
color: var(--colors-grey-500);
display: flex;
gap:4px ;
flex-direction: column;
align-items: center;
width: 460px;
@media (max-width: 535px) {
width: calc(100% - 90px);
margin: 0;
align-items: flex-start;
  } 
`
export const ShopSubBox = styled.div`
display: none;
align-items: center;
position: absolute;
top:calc(100% + 8px);
left: 0;
    border: 1px solid var(--colors-grey-100);
    border-radius: 24px;
    padding: 12px 12px;
z-index: 10;
    box-shadow: 0 2px 8px 0 rgba(152, 152, 179, 0.16);
    background: var(--colors-grey-25);
    width:760px;
   &.active{
display: flex;
}
gap:10px;
@media (max-width: 1000px) {
width:420px;
flex-wrap: wrap;
left: unset;
right:0;

  } 
  
@media (max-width: 535px) {
flex-wrap: wrap;
right: unset;
left: 0;
justify-content: space-between;
gap: 10px;
width: 100%;
  } 

`
export const ChoiceStatus = styled.span`
    font-family: var(--font-family);
    font-weight: 500;
    font-size: 16px;
    line-height: 135%;
    color: var(--colors-grey-600);
  
  display: flex;
  align-items: center;
 
`;
export const TimeTitle = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 135%;
color: var(--colors-grey-600);


`

export const TimeTitle1 = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 135%;
color: var(--colors-grey-600);
max-width: 70px;

`

export const TimeText = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 100%;
color: var(--colors-grey-600);

`

export const CustomLabel = styled.label`
margin-left: 10px;
border-radius: 40px;
background-color: var(--colors-grey-300);
width:52px; 
height:28px;
padding:2px;
box-sizing: border-box;
cursor: pointer;
position: relative;
&::before{
  content:"";
  border-radius: 360px;
width: 24px;
height: 24px;
background: var(--colors-grey-25);
top: 50%;
transform: translate(0, -50%);
left:2px;
 transition: transform 0.3s ease;
  position: absolute;
}
`;
export const Checkbox = styled.input`
 opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
  &:checked + label {
    background-color: var(--colors-primary-600);

    &::before {
      transform: translate(24px, -50%);
    }
  }
`;